import { FC, useEffect, useState } from 'react';
import { getIsLogin } from '@/utils/cookie';

interface TheProps {
    children?: React.ReactNode;
}

const NeedLoginShow: FC<TheProps> = ({ children }) => {
    const [isLogin, setIsLogin] = useState(false);
    useEffect(() => {
        const isLogin2 = getIsLogin();
        setIsLogin(isLogin2);
    }, []);
    if (!isLogin) {
        return null;
    }
    return <>{children}</>;
};

export default NeedLoginShow;
